import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import { Link } from "react-router-dom"

import "simplebar-react/dist/simplebar.min.css"

const SidebarContent = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const ref = useRef()

  // Initialize MetisMenu when component mounts or location changes
  useEffect(() => {
    const pathName = location.pathname
    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [location.pathname])

  useEffect(() => {
    if (ref.current) {
      ref.current.recalculate()
    }
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{t("Main")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-view-dashboard"></i>

                <span>{t("Dashboard")}</span>
              </Link>
            </li>
            <li>
              <Link to="/clients" className="waves-effect">
                <i className="mdi mdi-human-greeting "></i>
                <span>{t("Clients")}</span>
              </Link>
            </li>
            <li>
              <Link to="/allocations" className="waves-effect">
                <i className="mdi mdi-chart-pie"></i>

                <span>{t("Allocations")}</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/report-search" className="waves-effect">
                <i className="mdi mdi-chart-line"></i>

                <span>{t("Reports")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/add-holdings" className="waves-effect">
                <i className="mdi mdi-book-plus"></i>

                <span>{t("Add Holdings")}</span>
              </Link>
            </li>
            <li>
              <Link to="/scrip" className="waves-effect">
                <i className="mdi mdi-script-text"></i>

                <span>{t("Scrip")}</span>
              </Link>
            </li>
            <li>
              <Link to="/newsletter" className="waves-effect">
                <i className="mdi mdi-email-newsletter"></i>

                <span>{t("Newsletter")}</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/file-upload" className="waves-effect">
                <i className="mdi mdi-chart-line"></i>

                <span>{t("File Upload")}</span>
              </Link>
            </li> */}
            {/* <li className="menu-title">{t("Client")} </li> */}
            {/* 
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-human-greeting "></i>
                <span>{t("Client")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/clients">{t("Client List")}</Link>
                </li>
                <li>
                  <Link to="/clients/:id">{t("Client Details")} </Link>
                </li>
                <li>
                  <Link to="/clients/settings/:id">
                    {t("Client Settings")}{" "}
                  </Link>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  // Remove location prop since it's now coming from useLocation
  t: PropTypes.any, // Updated PropTypes
}

export default SidebarContent
